import { ControlledInput } from "@dune/ui";
import { useFormContext } from "react-hook-form";
import { ControlledPriceInput } from "../../components/inputs/ControlledPriceInput";

interface GFAFinancingCommercializationPlanContainerProps {
	isForm?: boolean;
}

const GFAFinancingCommercializationPlanContainer = ({
	isForm = true,
}: GFAFinancingCommercializationPlanContainerProps) => {
	const { control } = useFormContext();

	return (
		<div className="flex flex-col gap-4">
			{isForm && (
				<div className="flex flex-row gap-4">
					<h1 className="text-[#144C65] text-lg font-medium">
						PLAN DE COMMERCIALISATION
					</h1>
				</div>
			)}
			<div className="border rounded-lg p-4 flex flex-col gap-4">
				<ControlledInput
					name="numberOfLots"
					control={control}
					label="Nombre de lots"
					type="number"
					disabled={!isForm}
				/>
				<div className="flex flex-row gap-4">
					<ControlledPriceInput
						name="preCommercializationAmount"
						control={control}
						label="Montant de la pré-commercialisation"
						iconOrText="€"
						disabled={!isForm}
					/>
					<ControlledInput
						name="preCommercializationPercentage"
						control={control}
						label="% de pré-commercialisation"
						type="number"
						iconOrText="%"
						max={100}
						disabled={!isForm}
					/>
				</div>
				<div className="flex flex-row gap-4">
					<ControlledPriceInput
						name="clearedPreCommercializationAmount"
						control={control}
						label="Montant de la pré-co (€) purgée des conditions de financement"
						iconOrText="€"
						disabled={!isForm}
					/>
					<ControlledInput
						name="clearedPreCommercializationPercentage"
						control={control}
						label="% de pré-commercialisation purgée"
						type="number"
						iconOrText="%"
						max={100}
						disabled={!isForm}
					/>
				</div>
			</div>
		</div>
	);
};

export default GFAFinancingCommercializationPlanContainer;
